//to round up to three decimal places
export default function roundMoney(qty) {
    const num = qty < 0 ? -1 : 1;
    return qty === 0 ? 0 : Math.ceil(Math.abs(qty) * 100) / 100 * num;
}
